import Update_Icon from "../images/table/Update_icon.svg";
import Track_Icon from "../images/table/View_icon.svg";
import Delete_Icon from "../images/table/Delete_icon.svg";

export const FLEET_VEHICLE_ROW_ACTIONS = {
  updateVehicle: {
    id: "update",
    label: "Update",
    icon: Update_Icon,
    path: "/vehicle/add",
    permission: { apiPath: "/api/vehicle", action: "PUT" },
  },
  trackVehicle: {
    id: "track",
    label: "Track",
    icon: Track_Icon,
    path: "/vehicle/track",
    permission: { apiPath: "/api/vehicle/id", action: "GET" },
  },
  deleteVehicle: {
    id: "delete",
    label: "Delete",
    className: "delete",
    icon: Delete_Icon,
    path: "",
    permission: { apiPath: "/api/vehicle", action: "DELETE" },
  },
};

export function hasLayoutPermission(requiredPermission, hasPermission) {
  if (!requiredPermission?.apiPath) return true;
  if (typeof hasPermission !== "function") return true;
  return hasPermission(requiredPermission.apiPath, requiredPermission.action || "GET");
}

export function computeFleetVehicleMetric(metricKey, vehicleData = []) {
  const vehicles = Array.isArray(vehicleData) ? vehicleData : [];

  switch (metricKey) {
    case "totalVehicles":
      return vehicles.length;
    case "activeVehicles":
      return vehicles.filter((vehicle) => vehicle.status === "ACTIVE").length;
    case "inactiveVehicles":
      return vehicles.filter(
        (vehicle) =>
          vehicle.status === "INACTIVE" || vehicle.status === "DEAD" || !vehicle.status,
      ).length;
    case "deadVehicles":
      return vehicles.filter((vehicle) => vehicle.status === "DEAD" || !vehicle.status).length;
    default:
      return 0;
  }
}
